module.exports = __webpack_public_path__ + "img/verisure_vertrouwen.ec45c8fd.jpg";